import React, { Fragment } from 'react';
import { Outlet, Route, Routes } from 'react-router';
// import ErrorBoundary from 'src/components/ErrorBoundary';

const renderRoutes = (
  routes = [],
  { portal, app, registry },
  parentPath = ''
) =>
  routes.map((route, index) => {
    const elementProps = route.elementProps || {};
    const Guard = route.guard || Fragment;
    const Element = route.element || Outlet;
    // Create a unique key by combining the path and index to ensure uniqueness
    const routeKey = `${parentPath}-${route.path || 'index'}-${index}`;

    // Combine all props including elementProps
    const props = {
      ...elementProps,
      portal,
      app,
      registry
    };

    return 'children' in route ? (
      <Route
        path={route.path}
        key={routeKey}
        element={
          <Guard>
            <Element {...props} />
          </Guard>
        }
      >
        {renderRoutes(route.children, { portal, app, registry }, routeKey)}
      </Route>
    ) : (
      <Route
        path={route.path}
        key={routeKey}
        element={
          <Guard>
            {/* <ErrorBoundary portal={portal} app={app} registry={registry}> */}
            <Element {...props} />
            {/* </ErrorBoundary> */}
          </Guard>
        }
      />
    );
  });

const createRouter = (routes = [], { portal, app, registry }) => (
  <Routes>{renderRoutes(routes, { portal, app, registry })}</Routes>
);

export default createRouter;
